/**
 * @description
 * @author librajt
 * @date 2018-06-06
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export const userLogout = () => {
    return fetchData(Api.USER_LOGOUT).then((res: IResponse<{}>) => {
        return res;
    });
};
